/**
 * Route constants for the admin portal
 *
 * These constants define all application routes and should be used
 * throughout the application for navigation and route matching.
 */

export const ROUTES = {
  /** Dashboard landing page */
  DASHBOARD: '/',

  /** Tenant list page */
  TENANTS: '/tenants',

  /** Tenant detail page (requires tenantId parameter) */
  TENANT_DETAIL: '/tenants/:tenantId',

  /** User profile page */
  PROFILE: '/profile',

  /** User accounts management page */
  USERS: '/user-accounts',

  /** User account detail page (requires userId parameter) */
  USER_DETAIL: '/user-accounts/:userId',

  /** Theme colors page */
  THEME: '/theme',

  /** Feature toggles management page */
  FEATURE_TOGGLES: '/feature-toggles',
} as const

/**
 * Helper function to generate tenant detail route
 */
export const getTenantDetailRoute = (tenantId: string): string => {
  return `/tenants/${tenantId}`
}

/**
 * Helper function to generate user detail route
 */
export const getUserDetailRoute = (userId: string): string => {
  return `/user-accounts/${userId}`
}
